import { useQuery } from 'react-query';

import processingActivitiesApi from 'config/api/processingActivities/processingActivities';
import QUERY_KEYS from 'config/api/QUERY_KEYS';

const usePublishedProcessingActivityDetail = (organizationId?: number, processingActivityId?: number) =>
  useQuery(
    [QUERY_KEYS.PROCESSING_ACTIVITIES_GET_DETAIL, organizationId, processingActivityId],
    async () => {
      const { data } = await processingActivitiesApi.getDetail(organizationId as number, processingActivityId as number);
      return data;
    },
    {
      enabled: Boolean(organizationId && processingActivityId),
      retry: false,
    },
  );

export default usePublishedProcessingActivityDetail;
